module.exports = __webpack_public_path__ + "img/Hope with the student.46bfc31b.jpg";